export default __webpack_public_path__ + "static/media/warning.b265c8cf.wav";